import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AcademicPeriod } from "../../../../api";
import { useAuth } from "../../../../hooks";

const academicPeriodController = new AcademicPeriod();

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

export function AcademicPeriodForm(props) {
  const { onClose, onReload, period } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: {
      name: period?.name || "",
      startDate: formatDateForInput(period?.startDate) || "",
      endDate: formatDateForInput(period?.endDate) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("El nombre es obligatorio"),
      startDate: Yup.date().required("La fecha de inicio es obligatoria"),
      endDate: Yup.date()
        .required("La fecha de fin es obligatoria")
        .min(
          Yup.ref("startDate"),
          "La fecha de fin debe ser posterior a la fecha de inicio",
        ),
    }),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        await academicPeriodController.updatePeriod(accessToken, period.id, {
          name: formValue.name,
          startDate: formValue.startDate,
          endDate: formValue.endDate,
        });
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre del período"
        placeholder="Ej: 1er Bimestre"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Input
        name="startDate"
        label="Fecha de inicio"
        type="date"
        onChange={formik.handleChange}
        value={formik.values.startDate}
        error={formik.errors.startDate}
      />
      <Form.Input
        name="endDate"
        label="Fecha de fin"
        type="date"
        onChange={formik.handleChange}
        value={formik.values.endDate}
        error={formik.errors.endDate}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Actualizar período
      </Form.Button>
    </Form>
  );
}
